import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = (prop) => {
  const { currentUser } = React.useContext(AuthContext);

  return !currentUser ? <Navigate to='/login' replace /> : <Outlet />;
};

export default ProtectedRoute;
